module.exports = __webpack_public_path__ + "img/docs-icon.a25aba6d.svg";